import { ConfigFn } from '@config/types'

const config = (({ chatbotChatUrl, chatbotQuestionsUrl }) =>
  ({
    questionsUrl: `${chatbotQuestionsUrl}/api/v1/questions`,
    answerUrl: `${chatbotQuestionsUrl}/api/v2/answer`,
    chatUrl: `${chatbotChatUrl}/api/v2/chat`,
    localStorageHideAISearchBadgeKey: 'ai_search_badge_seen',
  }) as const) satisfies ConfigFn

export default config
